import { CM_PRIMARY_ID, ELECTION_TYPE } from './constants';
/**
 * Filters table data based on observer committee permissions
 * @param {Array} allTableData - Complete table data
 * @param {Array} observerCommitteeIds - Array of committee IDs the observer has access to
 * @returns {Array} Filtered table data
 */
export const filterObserverCommittees = (allTableData, observerCommitteeIds) =>
  allTableData.filter((row) => {
    // For regular sectional committees (1-13), check sectionalCommitteeId
    if (
      row.sectionalCommitteeId &&
      observerCommitteeIds.includes(row.sectionalCommitteeId)
    ) {
      return true;
    }

    // For CMSE (ID 14): show BOTH Corresponding Membership AND Special Election
    if (observerCommitteeIds.includes(CM_PRIMARY_ID)) {
      if (
        row.electionTypeId === ELECTION_TYPE.CORRESPONDING_MEMBER ||
        row.electionTypeId === ELECTION_TYPE.SPECIAL_ELECTION
      ) {
        return true;
      }
    }

    return false;
  });
